import React, { useState, useEffect, useRef } from 'react'

import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import { DataGrid, GridOverlay, useGridApiContext, useGridSelector, gridPageCountSelector, gridPageSelector, gridPageSizeSelector } from '@mui/x-data-grid'
import Pagination from '@material-ui/lab/Pagination'
import ListAlt from '@material-ui/icons/ListAlt';
import Search from '@material-ui/icons/Search';
import Close from '@material-ui/icons/Close';

import { useStoreRehydrated } from '@store'

import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { format } from 'date-fns'

import { sdocAdmin } from '@api'
import Swal from 'sweetalert2/dist/sweetalert2.js'

function CustomPagination() {
    const apiRef = useGridApiContext()
    const page = useGridSelector(apiRef, gridPageSelector)
    const pageSize = useGridSelector(apiRef, gridPageSizeSelector)
    const pageCount = useGridSelector(apiRef, gridPageCountSelector)

    return (
        <Grid className="flex flex-row items-center w-full justify-between px-2">
            <Grid className="flex flex-row items-center">
                <Typography variant="body2" className="mr-2">Rows per page:</Typography>
                <Select
                    value={pageSize}
                    onChange={(e) => apiRef.current.setPageSize(Number(e.target.value))}
                    disableUnderline
                >
                    {[5, 10, 25, 50].map((size) => (
                        <MenuItem key={size} value={size}>
                            {size}
                        </MenuItem>
                    ))}
                </Select>
            </Grid>
            <Pagination
                className="p-2"
                color="primary"
                count={pageCount}
                page={page + 1}
                onChange={(event, value) => apiRef.current.setPage(value - 1)}
                showFirstButton
                showLastButton
            />
        </Grid>
    );
}


export default function POALIST() {
    const isRehydrated = useStoreRehydrated()
    const [rowsPOAList, setRowsPOAList] = useState([]);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(0)
    const [totalRows, setTotalRows] = useState(0)
    const [isDataLoading, setIsDataLoading] = useState(true)
    const [activeFilters, setActiveFilters] = useState({})
    const [activeSort, setActiveSort] = useState({ field: 'startDate', sort: 'desc' })
    const [sortModel, setSortModel] = useState([{ field: 'startDate', sort: 'desc' }])
    // Native DataGrid column-filter -> API params (merged into every fetch)
    const gridFilterParamsRef = useRef({})
    const gridFilterTimerRef = useRef(null)
    const [gridFilterModel, setGridFilterModel] = useState({ items: [] })

    // Filter dialog state
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [isDialogOpen, setIsDialogOpen] = useState(false)
    const [isSaveSearch, setIsSaveSearch] = useState(false)
    const [searchNationalID, setSearchNationalID] = useState('')
    const [searchJuristicNo, setSearchJuristicNo] = useState('')
    const [searchStartDateFrom, setSearchStartDateFrom] = useState('')
    const [searchEndDateTo, setSearchEndDateTo] = useState('')
    const [selectedStatus, setSelectedStatus] = useState('')

    const columnsPOAList = [
        {
            field: 'nationalID',
            headerName: 'ข้อมูลผู้รับมอบอำนาจ',
            width: 300,
            headerAlign: 'left',
            align: 'center',
            sortable: true,
            editable: false,
            renderCell: (params) => {
                return (
                    <Grid style={{ lineHeight: "normal", whiteSpace: "normal" }}>
                        {params.row.operatorUser?.prefix}{params.row.operatorUser?.firstname} {params.row.operatorUser?.lastname}<br />
                        ({params.row.nationalID})
                    </Grid>
                )
            },
            valueGetter: (value, row) => {
                return `${row.operatorUser?.prefix}${row.operatorUser?.firstname} ${row.operatorUser?.lastname} (${row.nationalID})`
            }
        },
        {
            field: 'juristicNo',
            headerName: 'ข้อมูลนิติบุคคล',
            width: 400,
            headerAlign: 'left',
            align: 'center',
            sortable: true,
            editable: false,
            renderCell: (params) => {
                return (
                    <Grid style={{ lineHeight: "normal", whiteSpace: "normal" }}>
                        {params.row.operator?.operatorName || "ไม่พบข้อมูล"}<br />
                        ({params.row.juristicNo})
                    </Grid>
                )
            },
            valueGetter: (value, row) => {
                return `${row.operator?.operatorName || "ไม่พบข้อมูล"} (${row.juristicNo})`
            }
        },
        {
            field: 'startDate',
            headerName: 'วันที่เริ่มต้นมอบอำนาจ',
            width: 250,
            headerAlign: 'left',
            align: 'center',
            sortable: true,
            filterable: false,
            editable: false,
            renderCell: (params) => {
                return format(new Date(params.value), 'dd/MM/yyyy')
            }
        },
        {
            field: 'endDate',
            headerName: 'วันที่สิ้นสุดมอบอำนาจ',
            width: 250,
            headerAlign: 'left',
            align: 'center',
            sortable: true,
            filterable: false,
            editable: false,
            renderCell: (params) => {
                return format(new Date(params.value), 'dd/MM/yyyy')
            }
        },
        {
            field: 'status',
            headerName: 'สถานะ',
            width: 150,
            headerAlign: 'left',
            align: 'center',
            sortable: true,
            filterable: false,
            editable: false,
            renderCell: (params) => {
                const start = new Date(params.row.startDate)
                const end = new Date(params.row.endDate)
                const today = new Date()
                if (today < start) {
                    return <Grid style={{ lineHeight: "normal", whiteSpace: "normal", color: "orange" }}>รอเริ่มต้น</Grid>
                } else if (today > end) {
                    return <Grid style={{ lineHeight: "normal", whiteSpace: "normal", color: "gray" }}>หมดอายุ</Grid>
                } else {
                    return <Grid style={{ lineHeight: "normal", whiteSpace: "normal", color: "green" }}>กำลังใช้งาน</Grid>
                }
            },
            valueGetter: (value, row) => {
                const start = new Date(row.startDate)
                const end = new Date(row.endDate)
                const today = new Date()
                if (today < start) return "รอเริ่มต้น"
                else if (today > end) return "หมดอายุ"
                else return "กำลังใช้งาน"
            }
        }
    ];

    const getPOAList = async (page = 0, filters = {}, size = pageSize, sort = activeSort) => {
        setIsDataLoading(true)
        setRowsPOAList([])
        const res = await sdocAdmin.getPOAList({ page: page + 1, pageSize: size, ...filters, ...gridFilterParamsRef.current, ...(sort?.field ? { sortField: sort.field, sortOrder: sort.sort } : {}) })
        if (res && res.status === 200) {
            const { data, total } = res.data
            if (data) {
                setRowsPOAList(data)
                setTotalRows(total)
            }
        }
        setIsDataLoading(false)
    }

    const buildFilterParams = () => {
        const params = {}
        if (searchNationalID) params.nationalID = searchNationalID
        if (searchJuristicNo) params.juristicNo = searchJuristicNo
        if (searchStartDateFrom) params.startDateFrom = searchStartDateFrom
        if (searchEndDateTo) params.endDateTo = searchEndDateTo
        if (selectedStatus) params.status = selectedStatus
        return params
    }

    const applySavedFilters = () => {
        const saved = localStorage.getItem('savedFiltersPOA')
        if (saved) {
            try {
                const parsed = JSON.parse(saved)
                setIsSaveSearch(true)
                setSearchNationalID(parsed.searchNationalID || '')
                setSearchJuristicNo(parsed.searchJuristicNo || '')
                setSearchStartDateFrom(parsed.searchStartDateFrom || '')
                setSearchEndDateTo(parsed.searchEndDateTo || '')
                setSelectedStatus(parsed.selectedStatus || '')
                const params = {}
                if (parsed.searchNationalID) params.nationalID = parsed.searchNationalID
                if (parsed.searchJuristicNo) params.juristicNo = parsed.searchJuristicNo
                if (parsed.searchStartDateFrom) params.startDateFrom = parsed.searchStartDateFrom
                if (parsed.searchEndDateTo) params.endDateTo = parsed.searchEndDateTo
                if (parsed.selectedStatus) params.status = parsed.selectedStatus
                return params
            } catch { }
        }
        return {}
    }

    const onSearchResult = () => {
        if (isSaveSearch) {
            localStorage.setItem('savedFiltersPOA', JSON.stringify({ searchNationalID, searchJuristicNo, searchStartDateFrom, searchEndDateTo, selectedStatus }))
        } else {
            localStorage.removeItem('savedFiltersPOA')
        }
        const filters = buildFilterParams()
        setActiveFilters(filters)
        setCurrentPage(0)
        setIsDialogOpen(false)
        getPOAList(0, filters)
    }

    const onSearchResultClear = () => {
        setSearchNationalID('')
        setSearchJuristicNo('')
        setSearchStartDateFrom('')
        setSearchEndDateTo('')
        setSelectedStatus('')
        setIsSaveSearch(false)
        localStorage.removeItem('savedFiltersPOA')
        setActiveFilters({})
        setCurrentPage(0)
        setIsDialogOpen(false)
        getPOAList(0, {})
    }

    const lastSortKeyRef = useRef('startDate|desc');
    const sortTimerRef = useRef(null);
    const handleSortChange = (model) => {
        if (sortTimerRef.current) clearTimeout(sortTimerRef.current);
        sortTimerRef.current = setTimeout(() => {
            const sort = model[0] || { field: '', sort: '' };
            const key = `${sort.field}|${sort.sort}`;
            if (key === lastSortKeyRef.current) return;
            lastSortKeyRef.current = key;
            setSortModel(model);
            setActiveSort(sort);
            setCurrentPage(0);
            if (isRehydrated) {
                getPOAList(0, activeFilters, pageSize, sort);
            }
        }, 0);
    }

    // Native DataGrid column filter -> server params (same field map as the filter dialog)
    const gridFieldToApi = {
        nationalID: 'nationalID',
        juristicNo: 'juristicNo',
    };
    const handleFilterChange = (model) => {
        setGridFilterModel(model);
        if (gridFilterTimerRef.current) clearTimeout(gridFilterTimerRef.current);
        gridFilterTimerRef.current = setTimeout(() => {
            const params = {};
            (model.items || []).forEach(({ field, value }) => {
                const key = gridFieldToApi[field];
                if (!key || value === undefined || value === null || value === '') return;
                params[key] = value;
            });
            gridFilterParamsRef.current = params;
            setCurrentPage(0);
            getPOAList(0, activeFilters);
        }, 500);
    };
    useEffect(() => {
        if (isRehydrated) {
            const savedFilters = applySavedFilters()
            getPOAList(0, savedFilters)
        }
        // eslint-disable-next-line
    }, [isRehydrated])

    return (
        <>
            <Grid className="flex flex-col">
                <Grid className="p-10">
                    <Card className={`border-t-4 border-card_top_border`}>
                        <Grid className="flex flex-col justify-center items-start overflow-auto mb-5">
                            <Grid className="flex flex-row items-center mt-4 mb-3 px-5">
                                <Grid>
                                    <ListAlt style={{ fontSize: 22 }} className="mr-1" />
                                </Grid>
                                <Grid className="font-bold text-sm text-card_header_color">
                                    รายการมอบอำนาจภายในระบบ SDoC
                                </Grid>
                            </Grid>
                            <Grid className="flex flex-row items-center mt-2 mb-3 px-5 gap-x-2">
                                <Button
                                    className={`w-36`}
                                    color="primary"
                                    variant="contained"
                                    onClick={() => setIsDialogOpen(true)}>
                                    <Search style={{ fontSize: 16 }} className="mr-1" />
                                    <Grid className={`text-xs`}>ค้นหาขั้นสูง</Grid>
                                </Button>
                            </Grid>
                            <Grid className="md:px-5" style={{ height: '80vh', width: '100%', overflow: 'hidden' }}>
                                <DataGrid
                                    rows={rowsPOAList}
                                    columns={columnsPOAList}
                                    loading={isDataLoading}
                                    paginationMode="server"
                                    rowCount={totalRows}
                                    paginationModel={{ page: currentPage, pageSize }}
                                    onPaginationModelChange={(model) => {
                                        const pageSizeChanged = model.pageSize !== pageSize
                                        setPageSize(model.pageSize)
                                        setCurrentPage(pageSizeChanged ? 0 : model.page)
                                        getPOAList(pageSizeChanged ? 0 : model.page, activeFilters, model.pageSize)
                                    }}
                                    pageSizeOptions={[5, 10, 25, 50]}
                                    disableRowSelectionOnClick
                                    sortingMode="server"
                                    filterMode="server"
                                    filterModel={gridFilterModel}
                                    onFilterModelChange={handleFilterChange}
                                    onSortModelChange={(model) => { handleSortChange(model) }}
                                    rowHeight={66}
                                    slots={{
                                        pagination: CustomPagination,
                                        noRowsOverlay: () => <GridOverlay>ไม่พบข้อมูล</GridOverlay>,
                                    }}
                                    slotProps={{
                                        loadingOverlay: { variant: 'skeleton', noRowsVariant: 'skeleton' },
                                    }}
                                    sx={{ fontFamily: 'Sarabun, sans-serif', '& .MuiDataGrid-cell': { display: 'flex', alignItems: 'center' } }}
                                />
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
            </Grid>

            {/* Filter Dialog */}
            <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)} fullScreen={isMobile} fullWidth maxWidth="sm">
                <DialogTitle style={{ backgroundColor: '#a74345', padding: '8px 16px' }}>
                    <Grid container direction="row" justifyContent="space-between" alignItems="center">
                        <Grid className="text-white text-sm font-bold">ค้นหาขั้นสูง</Grid>
                        <IconButton onClick={() => setIsDialogOpen(false)} style={{ color: '#fff' }}>
                            <Close />
                        </IconButton>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} className="mt-2">
                        <Grid item xs={12}>
                            <Typography variant="body2" className="mb-1">เลขบัตรประชาชน</Typography>
                            <TextField
                                fullWidth
                                variant="outlined"
                                size="small"
                                placeholder="ค้นหาเลขบัตรประชาชน"
                                value={searchNationalID}
                                onChange={(e) => setSearchNationalID(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="body2" className="mb-1">เลขทะเบียนนิติบุคคล</Typography>
                            <TextField
                                fullWidth
                                variant="outlined"
                                size="small"
                                placeholder="ค้นหาเลขทะเบียนนิติบุคคล"
                                value={searchJuristicNo}
                                onChange={(e) => setSearchJuristicNo(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={isMobile ? 12 : 6}>
                            <Typography variant="body2" className="mb-1">วันที่เริ่มต้นมอบอำนาจ (ตั้งแต่)</Typography>
                            <TextField
                                fullWidth
                                variant="outlined"
                                size="small"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                value={searchStartDateFrom}
                                onChange={(e) => setSearchStartDateFrom(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={isMobile ? 12 : 6}>
                            <Typography variant="body2" className="mb-1">วันที่สิ้นสุดมอบอำนาจ (ถึง)</Typography>
                            <TextField
                                fullWidth
                                variant="outlined"
                                size="small"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                value={searchEndDateTo}
                                onChange={(e) => setSearchEndDateTo(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="body2" className="mb-1">สถานะ</Typography>
                            <Select
                                fullWidth
                                variant="outlined"
                                value={selectedStatus}
                                onChange={(e) => setSelectedStatus(e.target.value)}
                                displayEmpty
                            >
                                <MenuItem value="">ทั้งหมด</MenuItem>
                                <MenuItem value="active">กำลังใช้งาน</MenuItem>
                                <MenuItem value="expired">หมดอายุ</MenuItem>
                                <MenuItem value="pending">รอเริ่มต้น</MenuItem>
                            </Select>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={isSaveSearch}
                                        onChange={(e) => setIsSaveSearch(e.target.checked)}
                                        color="primary"
                                    />
                                }
                                label="บันทึกการค้นหา"
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onSearchResultClear} color="secondary" variant="outlined">
                        ล้างผลการค้นหา
                    </Button>
                    <Button onClick={onSearchResult} color="primary" variant="contained">
                        ค้นหา
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
